import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ConsultantChatGate from '../components/ConsultantChatGate';
import RequestCalculationForm from '../components/RequestCalculationForm';
import SEOHead from '../components/SEOHead';
import { DISCUSS_TASK_PAGE_PATH } from '../lib/discussTaskLinks';
import { PAGE_SEO } from '../data/pageSeo';

const DiscussTaskPage = () => {
  const [searchParams] = useSearchParams();
  const score = searchParams.get('checklist_score');
  const maxScore = searchParams.get('checklist_max');
  const seoData = PAGE_SEO[DISCUSS_TASK_PAGE_PATH];

  const checklistSummary =
    score && maxScore ? `Результат чек-листа: ${score} из ${maxScore}` : null;

  return (
    <div className="min-h-screen flex flex-col">
      <SEOHead
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical={seoData.canonical}
      />
      <Header />

      <main className="flex-1 bg-[#ECEBF2]" style={{ paddingTop: '5rem' }}>
        <section className="mx-auto w-full max-w-lg px-4 py-12 sm:px-6 sm:py-16">
          {checklistSummary && (
            <p className="mb-4 text-center text-sm text-[#62748E]">{checklistSummary}</p>
          )}
          <RequestCalculationForm
            variant="inline"
            calculatorData={null}
          />
        </section>
      </main>

      <Footer />
      <ConsultantChatGate />
    </div>
  );
};

export default DiscussTaskPage;
